import { Wrap, WrapItem } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import { FiFileText, FiShoppingCart } from "react-icons/fi";
import type { EntityHighlight } from "./agentTypes";
import { inferEntityHighlightKind } from "./entityHighlights";
import { LinkCard } from "./LinkCard";

type LookupEntity = (id: string) => Record<string, unknown> | undefined;

const ICON_BY_KIND: Record<"contract" | "event", IconType> = {
  contract: FiFileText,
  event: FiShoppingCart,
};

// Small clickable cards for the entities a turn's tool calls surfaced (a created/updated contract, a
// sourcing event/project/need the user just asked about) — lets the user jump straight to that page
// instead of asking the assistant to navigate for them. The icon is a best-effort contract/event sniff
// (see inferEntityHighlightKind); anything else — project, need — renders label-only.
export const EntityHighlightCards = ({
  entities,
  lookupEntity,
  onOpen,
}: {
  entities: EntityHighlight[];
  lookupEntity: LookupEntity;
  onOpen: (id: string) => void;
}) => (
  <Wrap spacing="2">
    {entities.map((entity) => {
      const kind = inferEntityHighlightKind(lookupEntity(entity.id));
      const icon = kind ? ICON_BY_KIND[kind] : undefined;
      return (
        <WrapItem key={entity.id}>
          <LinkCard icon={icon} label={entity.label} sublabel={entity.sublabel} onOpen={() => onOpen(entity.id)} />
        </WrapItem>
      );
    })}
  </Wrap>
);
